import { Button, Callout, InputGroup, Tab, TabId, Tabs } from '@blueprintjs/core'
import { WorkspaceUserWithAttributes } from 'enablex/sdk'
import { lang, utils } from 'enablex/shared'
// import { CHAT_USER_ROLE } from 'common/defaults'
import _ from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import LoadingSection from '~/app/common/LoadingSection'
import { AppState } from '~/app/rootReducer'
import { filterList } from '~/workspace/util'
import style from '../style.scss'
import RoleSection from '../UserList/RoleSection'
import cx from 'classnames'
import { toggleAnalyticsWindow } from '../reducer'
import { fetchBots } from '~/workspace/bots/reducer'

const userFilterFields = ['email', 'attributes.firstname', 'attributes.lastname']

type Props = {
  onPasswordReset: any
  onUserUpdated: () => void
  openModal?: any
} & ConnectedProps<typeof connector>

const UserList: FC<Props> = props => {
  const [filter, setFilter] = useState('')
  const [isLaptopScreen, setletIsLaptopScreen] = useState(false)

  // Get current user's role from localStorage
  const currentUserRole = localStorage.getItem('enx/channel-web/user-role')

  // Set default tab based on user role
  const getDefaultTabId = () => {
    if (currentUserRole === 'supervisor') {
      return 'agent'
    }
    return props.roles[0]?.id
  }

  const [navbarTabId, setNavbarTabId] = useState(getDefaultTabId() as any)
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  })

  useEffect(() => {
    if (!props.bots.length) {
      props.fetchBots()
    }
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      })
      console.log(windowDimensions.width, isLaptopScreen)
    }
    window.addEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setletIsLaptopScreen(windowDimensions.width <= 1344 ? true : false)
  }, [windowDimensions])

  if (!props.users || props.loading || !props.roles) {
    return <LoadingSection />
  }
  const currentUserEmail = _.get(props.profile, 'email', '').toLowerCase()
  const currentUserisAdminUser = !!_.get(props.profile,'isAdminUser')
  const currentUserisSuperAdmin = !!_.get(props.profile,'isSuperAdmin')
  const currentUserisEnablexAdmin =  !!_.get(props.profile,'isEnablexAdmin')

  // Filter roles based on current user's role
  const filteredRoles = currentUserRole === 'supervisor'
    ? props.roles.filter(role => role.id === 'agent')
    : props.roles

  const filteredUsers = filterList<WorkspaceUserWithAttributes>(props.users, userFilterFields, filter)
  const roles = filteredRoles

  const handleNavbarTabChange = (selNavbarTabId: TabId) => {
    setNavbarTabId(selNavbarTabId)
  }

  const branding = utils.getBranding()
  const brandName = branding?.pageTitle || 'EnableX Dialogs'
  return (
    <div className={cx(style.containerLeft, { [style.show]: !isLaptopScreen })}>
      <div className={cx({ [style.forLaptop]: !isLaptopScreen })}>
        <div className={style.filterWrapper}>
          <div className={style.filterTitleContainer}>
            <div className={style.filterTitle}>Users</div>
            <InputGroup
              id="input-filter"
              placeholder={lang.tr('admin.workspace.users.collaborators.filterUsers')}
              value={filter}
              onChange={e => setFilter(e.target.value.toLowerCase())}
              autoComplete="off"
              type="search"
              className={style.searchUsersFilter}
            />
          </div>
          {currentUserRole !== 'supervisor' && (
            <Button
              id="btn-create-collaborator"
              // style={{ width: 160 }}
              text={lang.tr('admin.workspace.users.collaborators.add')}
              icon="add"
              onClick={() => props.openModal(true)}
              className={style.createNewUserBtn}
            />
          )}
        </div>

        <div className={style.container}>
          <div className={style.heroSectionText}>
            View and manage details and activities for Admins, Agents, and Developers.
          </div>

          {/* {!props.users.length && (
            <Callout
              className={style.filterCallout}
              title={lang.tr('admin.workspace.users.collaborators.noCollaboratorsYet')}
              style={{ textAlign: 'center' }}
            />
          )} */}

          {(
            <Tabs
              id={'div-role-users'}
              key={'horizontal'}
              onChange={handleNavbarTabChange}
              large={true}
              vertical={false}
              animate={true}
              selectedTabId={navbarTabId}
            >
              {roles.map(role => {
                let users = filteredUsers.filter(user => user.role === role.id)

                // If current user is supervisor and we're showing the agent tab, include only their assigned agents
                if (currentUserRole === 'supervisor' && role.id === 'agent') {
                  users = filteredUsers.filter(user => {
                    // Include only agents assigned to this supervisor
                    if (user.role === 'agent' && user.supervisor_id === currentUserEmail) {
                      return true
                    }
                    return false
                  })
                }

                return (
                  <Tab
                    id={role.id}
                    title={`${lang.tr(role.name)} (${users.length})`}
                    panel={
                      <RoleSection
                        selectedTabId={navbarTabId}
                        isAgentAnalyticsOpen={props.isAgentAnalyticsOpen}
                        toggleAgentAnalyticsWindow={props.toggleAnalyticsWindow}
                        key={role.id}
                        users={users}
                        role={role}
                        currentUserEmail={currentUserEmail}
                        currentUserisAdminUser = {currentUserisAdminUser}
                        currentUserisSuperAdmin = {currentUserisSuperAdmin}
                        currentUserisEnablexAdmin = {currentUserisEnablexAdmin}
                        onUserUpdated={props.onUserUpdated}
                        onPasswordReset={props.onPasswordReset}
                      />
                    }
                  />
                )
              })}
              <Tabs.Expander />
            </Tabs>
          )}
        </div>
      </div>
      {!isLaptopScreen && (
        <div
          style={{
            width: '25%',
            background: '#fff',
            height: 'fit-content',
            borderRadius: '10px',
            padding: '10px 1.5rem  1.5rem  1.5rem'
            // marginRight: '50px'
          }}
        >
          <h3>Get started with {brandName}</h3>
          <div>
            <video src={'https://portal.enablex.io/dialogs/EnableX_Engage_bot.mp4'} poster={'admin/video/video_poster.jpg'} preload="auto" style={{ width: '100%' }} controls />
          </div>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  isAgentAnalyticsOpen: state.collaborators.isAgentAnalyticsOpen,
  profile: state.user.profile,
  roles: state.roles.roles,
  users: state.collaborators.users,
  loading: state.collaborators.loading,
  bots: state.bots.bots
})

const connector = connect(mapStateToProps, { toggleAnalyticsWindow, fetchBots })

export default connector(UserList)
